export const PARENT_ACCESS_PREFIX = 'PaL'
export const CHILD_ACCESS_PREFIX = 'CaL'
